<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2 2C1.5 2 0.999994 2.44772 1 3.00001C1.00001 3.55229 1.5 4 2 3.99999H12C12.5 3.99999 13 3.55229 13 3.00001C13 2.44772 12.5 2 12 2H2ZM5.97534 7C5.5 7 5 7.45448 5 8C5 8.54552 5.5 8.99999 5.97534 8.99999H14C14.5 9 15 8.55228 15 8C15 7.44772 14.5 7 14 7H5.97534ZM6 13C5.5 13 5 13.4477 5 14C5 14.5523 5.5 15 6 15H14C14.5 15 15 14.5523 15 14C15 13.4477 14.5 13 14 13H6ZM3 8C3 7.5 2.55229 6.99999 2 6.99999C1.44771 6.99999 1 7.5 1 8V14C1 14.5 1.44772 15 2 15C2.55229 15 3 14.5 3 14V8Z"
    fill="currentColor"
  />
</svg>
